import ProfileStore from '../../store/profiles';
import { logger } from 'logging-utils';
import { snapshot } from 'valtio';
import { IFetchProfileDetailsRes } from '../../types/policy-profile-types';
import policiesService from '../../services';
import {
  enablePoliciesSaveButton,
  setGeneralPoliciesPageError,
  setLoadingProfile,
} from '../policies-selection-ui-actions/policies-selection-ui-actions';
import PoliciesStore from '../../store/policies';

export const changeProfileInContext = async (selectedProflieId: string) => {
  try {
    setLoadingProfile(true);
    const profileStore = snapshot(ProfileStore);
    const profileInContext = profileStore.profiles.find(
      p => p.profileId === selectedProflieId,
    );

    ProfileStore.profileInContext = profileInContext
      ? { ...profileInContext }
      : undefined;

    const {
      policiesPerCategoriesInfo,
      enabledPolicies,
      totalPolicies,
      profile,
    }: IFetchProfileDetailsRes = await policiesService.fetchProfileDetailsById.execute(
      selectedProflieId,
    );

    ProfileStore.profileInContext = profile;
    ProfileStore.totalPolicies = totalPolicies;
    ProfileStore.enabledPolicies = enabledPolicies;
    ProfileStore.policiesPerCategoriesInfo = policiesPerCategoriesInfo;
    PoliciesStore.policies = {};
    PoliciesStore.dirtyPolicies = undefined;
  } catch (error) {
    logger.error('change profile in context error', { error });
    setGeneralPoliciesPageError({
      errorTitle: 'Missing Selected Profile Content',
      errorMsg:
        'Failed to load selected profile content, please try again later.',
    });
  } finally {
    setLoadingProfile(false);
    enablePoliciesSaveButton(false);
  }
};
